import axiosInstance from './axiosInstance'

export const getEdgeQuoteById = (quoteId) => {
  return axiosInstance.get(`/edge-quotes/${quoteId}`)
}

export const getEdgeQuoteByNumber = (quoteNumber) => {
  return axiosInstance.get(`/edge-quotes/by-number/${quoteNumber}`)
}

export const getEdgeQuotes = (page = 1, limit = 50, search = '', orderByKey = 'quoteNo', direction = 'asc') => {
  return axiosInstance.get(`/edge-quotes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportEdgeQuotes = ({ search = '', orderByKey = 'quoteNo', direction = 'desc' } = {}) => {
  return axiosInstance.get(`/edge-quotes/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createEdgeQuote = (data) => {
  return axiosInstance.post('/edge-quotes', data)
}

export const previewEdgeQuote = (data) => {
  return axiosInstance.post('/edge-quotes/preview', data)
}

export const updateEdgeQuote = (quoteId, data) => {
  return axiosInstance.put(`/edge-quotes/${quoteId}`, data)
}

export const deleteEdgeQuote = (quoteId) => {
  return axiosInstance.delete(`/edge-quotes/${quoteId}`)
}

export const convertEdgeQuoteToProjectById = (quoteId, data) => {
  return axiosInstance.post(`/edge-quotes/${quoteId}/convertToProject`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const getEdgeQuoteNoteById = (quoteId, noteId) => {
  return axiosInstance.get(`/edge-quotes/${quoteId}/notes/${noteId}`)
}

export const getEdgeQuoteNotes = (quoteId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/edge-quotes/${quoteId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createEdgeQuoteNote = (quoteId, data) => {
  return axiosInstance.post(`/edge-quotes/${quoteId}/notes`, data)
}

export const updateEdgeQuoteNote = (quoteId, noteId, data) => {
  return axiosInstance.put(`/edge-quotes/${quoteId}/notes/${noteId}`, data)
}

export const deleteEdgeQuoteNote = (quoteId, noteId) => {
  return axiosInstance.delete(`/edge-quotes/${quoteId}/notes/${noteId}`)
}
